<template>
  <div class="stats">
    <div class="stat">
      <div class="label">Started on</div>
      <div class="value">{{ assignment.started_at | shortDate }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stats",
  props: ["assignment"],
  components: {},
  data: function() {
    return {};
  },
  computed: {
    thisMonthName() {
      const date = new Date();
      return date.toLocaleString("en-us", { month: "long" });
    }
  }
};
</script>

<style scoped>
.stats {
  margin: 0px 0;
  padding: 28px 8px;
  padding-bottom: 18px;
}
.label {
  display: inline-block;
  width: 100px;
  font-size: 12pt;
  font-weight: 700;
  color: #2196f3;
  font-family: "Source Sans Pro";
}
.value {
  display: inline-block;
  width: 90px;
  font-size: 12pt;
  font-weight: 300;
  color: #222;
  font-family: "Source Sans Pro";
}
</style>
